import { forEach } from "lodash";

export class GeneralHomePage {
    detailsBox: HTMLElement | null;
    hubList: string[][] = [['CA'], ['NY', 'NJ', 'PA'], ['MD', 'DC'], ['TX', 'CT', 'KY'], ['MA'], ['GA']];
    currentHighlightedStates: string[] = [];

    //for NY and NJ they are also in TechMpower so figure out how to do the overlapping
    //KY also is included in stop
    constructor() {
        //document.ready
        $(() => {
            window.location.href = "/secure";
            this.detailsBox = document.getElementById('details-box') as HTMLElement;

            document.addEventListener('mouseover', (e: MouseEvent) => {
                this.handleMouseOver(e);
            });

            window.onmousemove = (e: MouseEvent) => {
                const x = e.clientX;
                const y = e.clientY;

                if (this.detailsBox) {
                    //this.detailsBox.style.top = `${y + 20}px`;
                    //this.detailsBox.style.left = `${x}px`;

                    // Get viewport dimensions
                    const viewportWidth = window.innerWidth;
                    const viewportHeight = window.innerHeight;

                    // Get detailsBox dimensions
                    const boxWidth = this.detailsBox.offsetWidth;
                    const boxHeight = this.detailsBox.offsetHeight;

                    // Calculate position
                    let newX = x;
                    let newY = y + 20; // Add offset below the cursor

                    // Adjust if the box would go out of bounds
                    if (newX - (boxWidth/2) < 0) {
                        newX = x + ((boxWidth/2) - x); // Align to the right edge
                    }
                    //if (newY + boxHeight > viewportHeight) {
                    //    newY = viewportHeight - boxHeight; // Align to the bottom edge
                    //}

                    // Apply the adjusted positions
                    this.detailsBox.style.left = `${newX}px`;
                    this.detailsBox.style.top = `${newY}px`;
                }
            };
        });
    }


    handleMouseOver(e: MouseEvent) {
        const target = e.target as HTMLElement;

        if (target.tagName === 'path') {
            const content = target.dataset.name;

            if (content && this.detailsBox) {
                this.highlightHub(target.dataset.id, `<div class="details-content">`+content+`</div>`);
            }
        } else if (this.detailsBox) {
            this.detailsBox.style.opacity = "0%";
            this.removeHighlightHub();
        }
    }

    highlightHub(stateId: string, content: string): void {
        if (this.hubList[0].includes(stateId)) {
            this.removeHighlightHub();

            forEach(this.hubList[0], (hub) => {
                document.getElementById(hub).classList.add("hover");
                if (!this.currentHighlightedStates.includes(hub)) this.currentHighlightedStates.push(hub);
            });
            this.detailsBox.innerHTML = content + `<br> <div class="details-subtext">Click For More Information</div>`;
            this.detailsBox.style.opacity = "100%";
        }
        else if (this.hubList[1].includes(stateId)) {
            this.removeHighlightHub();

            forEach(this.hubList[1], (hub) => {
                document.getElementById(hub).classList.add("hover");
                if (!this.currentHighlightedStates.includes(hub)) this.currentHighlightedStates.push(hub);
            });
            if (stateId === "NY" || stateId === "NJ") {
                this.detailsBox.innerHTML = content + `<br> <div class="horizontal-divider"></div> <br> <div class="details-content">TechMPower: Advancing HIV/SUD Care and Service Delivery for People Involved in the Criminal Legal System</div>` + `<br> <div class="details-subtext">Click For More Information</div>`;
            }
            else this.detailsBox.innerHTML = content + `<br> <div class="details-subtext">Click For More Information</div>`;
            this.detailsBox.style.opacity = "100%";
        }
        else if (this.hubList[2].includes(stateId)) {
            this.removeHighlightHub();

            forEach(this.hubList[2], (hub) => {
                document.getElementById(hub).classList.add("hover");
                if (!this.currentHighlightedStates.includes(hub)) this.currentHighlightedStates.push(hub);
            });
            this.detailsBox.innerHTML = content + `<br> <div class="details-subtext">Click For More Information</div>`;
            this.detailsBox.style.opacity = "100%";
        }
        else if (this.hubList[3].includes(stateId)) {
            this.removeHighlightHub();

            forEach(this.hubList[3], (hub) => {
                document.getElementById(hub).classList.add("hover");
                if (!this.currentHighlightedStates.includes(hub)) this.currentHighlightedStates.push(hub);
            });
            if (stateId === "KY") {
                this.detailsBox.innerHTML = content + `<br> <div class="horizontal-divider"></div> <br> <div class="details-content">STOP (Shared decision making to Treat Or Prevent) HIV in Justice Populations</div>` + `<br> <div class="details-subtext">Click For More Information</div>`;
            }
            else this.detailsBox.innerHTML = content + `<br> <div class="details-subtext">Click For More Information</div>`;
            this.detailsBox.style.opacity = "100%";
        }
        else if (this.hubList[4].includes(stateId)) {
            this.removeHighlightHub();

            forEach(this.hubList[4], (hub) => {
                document.getElementById(hub).classList.add("hover");
                if (!this.currentHighlightedStates.includes(hub)) this.currentHighlightedStates.push(hub);
            });
            this.detailsBox.innerHTML = content + `<br> <div class="details-subtext">Click For More Information</div>`;
            this.detailsBox.style.opacity = "100%";
        }
        else if (this.hubList[5].includes(stateId)) {
            this.removeHighlightHub();

            forEach(this.hubList[5], (hub) => {
                document.getElementById(hub).classList.add("hover");
                if (!this.currentHighlightedStates.includes(hub)) this.currentHighlightedStates.push(hub);
            });
            this.detailsBox.innerHTML = content + `<br> <div class="details-subtext">Click For More Information</div>`;
            this.detailsBox.style.opacity = "100%";
        }
        else {
            this.detailsBox.style.opacity = "0%";
            this.removeHighlightHub();
        }
    }

    removeHighlightHub(): void {
        forEach(this.currentHighlightedStates, (state) => {
            document.getElementById(state).classList.remove("hover");
        });
        this.currentHighlightedStates = [];
    }

    goToHubs(): void {
        window.location.href = "/general/hubs/hubs";
    }

}
